import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ListasolicitudessocketService {
  private listaSolicitidesSocket:any[] = [];

  constructor() { }

  obtenerListaSolicitudesSocket() {
    return this.listaSolicitidesSocket;
  }

  actualizarListaSolicitudesSocket( data: any[] ) {
    this.listaSolicitidesSocket = data;
  }

}
